import React from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { _NumberWrapper as NumberWrapper } from './Number.style';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';
import { _Label as Label } from '../../Styled/Label';

export const Number = ({ id, props }) => {
  const { label, description, required, minValue, maxValue } = props;
  const fieldName = `form['${label}']`;

  const { setFieldValue, values } = useFormikContext();
  const value = values.form[label] || 0;

  const updateValue = (newValue) => {
    setFieldValue(fieldName, newValue);
  };

  const handleIncrement = () => {
    if (value < maxValue) {
      const newValue = value + 1;
      updateValue(newValue);
    }
  };

  const handleDecrement = () => {
    if (value > minValue) {
      const newValue = value - 1;
      updateValue(newValue);
    }
  };

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10) || 0;
    updateValue(newValue);
  };

  return (
    <NumberWrapper>
      <Label htmlFor={id}>
        {label} {required ? '*' : ''}
      </Label>
      {description && <FieldDescription>{description}</FieldDescription>}
      <div>
        <button type='button' onClick={handleDecrement} disabled={value <= minValue}>
          &minus;
        </button>
        <Field
          id={id}
          name={fieldName}
          type='number'
          required={required}
          min={minValue}
          max={maxValue}
          value={value}
          onChange={handleChange}
        />
        <button type='button' onClick={handleIncrement} disabled={value >= maxValue}>
          &#43;
        </button>
      </div>
    </NumberWrapper>
  );
};

Number.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }).isRequired,
};
